// Campos calculados — versión mínima (v1). Soporta una sola operación:
//   <col> + <n|col>   /   <col> - <n|col>
// Si el primer operando es una columna de tipo fecha, el segundo se toma en días
// (ej. "FUM + 280"). Si no, suma/resta numérica. Cualquier cosa más compleja → ''.
const parseNum = (v) => {
  const n = Number(v)
  return Number.isFinite(n) ? n : null
}
const toDate = (v) => {
  const d = new Date(v)
  return isNaN(d.getTime()) ? null : d
}
const fmtDate = (d) => d.toISOString().slice(0, 10)

export const computeCalculated = (column, columns, data) => {
  const formula = String(column?.formula || '').trim()
  if (!formula) return ''

  const m = formula.match(/^([\w:/-]+)\s*([+-])\s*([\w:/-]+)$/)
  if (!m) return ''
  const [, aRef, op, bRef] = m
  const sign = op === '-' ? -1 : 1

  const resolve = (ref) => {
    const col = (columns || []).find((c) => c.id === ref || c.label === ref)
    return col ? { col, value: data?.[col.id] } : { col: null, value: ref }
  }
  const a = resolve(aRef)
  const b = resolve(bRef)

  if (a.col?.type === 'date') {
    const d = toDate(a.value)
    const days = parseNum(b.value)
    if (!d || days == null) return ''
    d.setDate(d.getDate() + sign * days)
    return fmtDate(d)
  }

  const an = parseNum(a.value)
  const bn = parseNum(b.value)
  if (an == null || bn == null) return ''
  return String(an + sign * bn)
}
